import type { ReactNode } from 'react';

import { Stack } from '#/components/Stack/Stack';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchRefinements } from '#/modules/search/hooks/refinements/useSearchRefinements';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { spacing } from '#/theme/theme';
import type { ListingType } from '#/types/ListingType';

import { SearchRefinementsHeader } from './Header/SearchRefinementsHeader';
import { SearchRefinementsOverflowDropdown } from './OverflowDropdown/SearchRefinementsOverflowDropdown';
import {
  SearchRefinementsBody,
  SearchRefinementsHolder,
} from './SearchRefinements.styled';

type Props = {
  listingType: ListingType;
  renderFacets: (details: { variant: SearchRefinementVariant }) => ReactNode;
};

export function SearchRefinements({ listingType, renderFacets }: Props) {
  const { locale } = useI18n();
  const { hasActiveRefinements, clearAllRefinements } =
    useSearchRefinements(listingType);

  return (
    <SearchRefinementsHolder
      id="sticky-search-refinements"
      data-qa-id="search-refinements"
      $locale={locale}
      role="search"
      onSubmit={(e) => e.preventDefault()}
    >
      <Stack direction="row" spacing={spacing[24]}>
        <SearchRefinementsHeader
          hasActiveRefinements={hasActiveRefinements}
          onClickClearAll={clearAllRefinements}
        />
        <SearchRefinementsBody className="search-refinements-body">
          {renderFacets({ variant: 'dropdown' })}
          <SearchRefinementsOverflowDropdown>
            {renderFacets({ variant: 'accordion' })}
          </SearchRefinementsOverflowDropdown>
        </SearchRefinementsBody>
      </Stack>
    </SearchRefinementsHolder>
  );
}
